import * as angular from "angular";
import {IController} from "angular";

export class PlanningDraftResourceSelectCtrl implements IController {

  selectedResource: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private searchTerm = '';

  /* @ngInject */
  constructor(private $mdSelect, private $filter) {}

  $onInit() {

  }

  getSelectedResourceName(resource) {
    if (!resource) {
      return this.$filter('translate')('Select resource');
    }
    return resource.allocationName || resource.vehicleName;
  }

  cancel() {
    this.$mdSelect.hide();
  }

  reset() {
    this.searchTerm = '';
    this.onChange({resource: undefined});
    this.$mdSelect.hide();
  }

}
angular
  .module('bringoz.admin.planning')
  .component('planningDraftResourceSelect', {
    bindings: {
      selectedResource: '<',
      options: '<',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./planning-draft-resource-select.html').default,
    controller: PlanningDraftResourceSelectCtrl
  });
